import React from "react";

import { Box, SxProps, Theme } from "@mui/material";
import { IgTypography } from "./IgTypography";
import {
  IgBasePrimitives,
  IgCoreBackgroundColors,
} from "@intelligems/ig-design-tokens/constants";

type IgBetaBadgeProps = {
  sx?: SxProps<Theme>;
};

/** Marks a feature in beta. Figma's "Chip" with the label "Beta". */
export const IgBetaBadge = ({ sx }: IgBetaBadgeProps) => {
  return (
    <Box
      sx={[
        {
          display: "flex",
          alignItems: "center",
          flexShrink: 0,
          height: "24px",
          px: "8px",
          borderRadius: "16px",
          backgroundColor: IgCoreBackgroundColors.accent,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IgTypography
        variant="body2"
        sx={{ color: IgBasePrimitives[700], fontWeight: 400, lineHeight: 1.5 }}
      >
        Beta
      </IgTypography>
    </Box>
  );
};
